(function() {
  if (!document.querySelector('[data-cart-crosssell]')) return;

  function box() { return document.querySelector('[data-cart-crosssell]'); }
  function list() { var b = box(); return b ? b.querySelector('.cart-recos__list') : null; }

  function updateArrows() {
    var b = box(), l = list();
    if (!b) return;
    var prev = b.querySelector('[data-reco-prev]'), next = b.querySelector('[data-reco-next]');
    if (!l || !prev || !next) return;
    var max = l.scrollWidth - l.clientWidth - 1;
    prev.disabled = l.scrollLeft <= 0;
    next.disabled = l.scrollLeft >= max;
  }

  /* Recomendaciones automáticas (Sections API) si no hay bloques manuales */
  function loadRecs(pid) {
    var b = box();
    if (!b || !pid) { updateArrows(); startAuto(); return; }
    fetch('/recommendations/products?section_id=cart-recommendations&product_id=' + pid + '&limit=8&intent=related')
      .then(function(r) { return r.ok ? r.text() : ''; })
      .then(function(html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var out = tmp.querySelector('[data-recommendations-output]');
        if (!out || out.children.length === 0) return;
        var grid = b.querySelector('[data-crosssell-grid]');
        if (!grid) return;
        grid.innerHTML = out.outerHTML;
        b.style.display = '';
        updateArrows();
        startAuto();
      })
      .catch(function() {});
  }

  function load() {
    var b = box();
    if (!b) return;
    if (b.hasAttribute('data-crosssell-manual')) { updateArrows(); startAuto(); return; }
    if (b.dataset.productId) { loadRecs(b.dataset.productId); return; }
    /* Sin producto de carrito (ej. página de wishlist): sembrar con el 1er deseo */
    if (window.Wishlist && window.Wishlist.all().length) {
      var h = window.Wishlist.all()[0].handle;
      fetch('/products/' + h + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) { b.dataset.productId = p.id; loadRecs(p.id); })
        .catch(function() { updateArrows(); startAuto(); });
      return;
    }
    updateArrows();
    startAuto();
  }

  /* Flechas: 1 card por click */
  document.addEventListener('click', function(e) {
    var dir = e.target.closest('[data-reco-prev]') ? -1 : (e.target.closest('[data-reco-next]') ? 1 : 0);
    if (!dir) return;
    var l = list();
    if (!l) return;
    e.preventDefault();
    var card = l.querySelector('.cart-reco');
    var step = card ? card.offsetWidth + 12 : l.clientWidth * 0.86;
    l.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function(e) {
    if (e.target && e.target.classList && e.target.classList.contains('cart-recos__list')) updateArrows();
  }, true);

  /* Autoplay: las cards avanzan solas; vuelve al inicio al llegar al final */
  var autoTimer = null;
  function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
  function startAuto() {
    var b = box();
    if (!b || !b.hasAttribute('data-autoplay')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var l = list();
    if (!l || l.querySelectorAll('.cart-reco').length < 3) return;
    stopAuto();
    var speed = (parseInt(b.getAttribute('data-autoplay-speed'), 10) || 4) * 1000;
    autoTimer = setInterval(function() {
      var lst = list();
      if (!lst) return;
      var max = lst.scrollWidth - lst.clientWidth - 1;
      var card = lst.querySelector('.cart-reco');
      var step = card ? card.offsetWidth + 12 : lst.clientWidth;
      if (lst.scrollLeft >= max) lst.scrollTo({ left: 0, behavior: 'smooth' });
      else lst.scrollBy({ left: step, behavior: 'smooth' });
    }, speed);
  }

  /* Pausa al pasar el mouse o tocar; reanuda al salir */
  (function bindPause() {
    var b = box();
    if (!b) return;
    b.addEventListener('mouseenter', stopAuto);
    b.addEventListener('mouseleave', startAuto);
    b.addEventListener('touchstart', stopAuto, { passive: true });
  })();

  /* Agregar accesorio: add + refrescar el carrito (evento a main-cart) + badge */
  function recoAdd(btn) {
    var vid = btn.getAttribute('data-variant-id');
    var handle = btn.getAttribute('data-handle');
    var url = btn.getAttribute('data-url');

    function add(id) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      /* Fuera de /cart (ej. wishlist): addToCart abre el sheet + actualiza badge */
      if (!document.querySelector('[data-cart-section]') && typeof window.addToCart === 'function') {
        window.addToCart(id, 1)
          .catch(function() { if (url) window.location.href = url; })
          .finally(function() { btn.disabled = false; btn.classList.remove('is-loading'); });
        return;
      }
      /* En /cart: add + re-render del listado (evento a main-cart) + badge */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
      .then(function(r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function() { return fetch('/cart.js'); })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function() { if (url) window.location.href = url; })
      .finally(function() { btn.disabled = false; btn.classList.remove('is-loading'); });
    }

    if (vid) { add(vid); return; }
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        if (p.variants && p.variants.length === 1 && p.variants[0].available) add(p.variants[0].id);
        else if (url) window.location.href = url;
      })
      .catch(function() { if (url) window.location.href = url; });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-reco-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    recoAdd(btn);
  });

  document.addEventListener('DOMContentLoaded', load);
  load();
})();
